import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { SessionService } from '@empathyco/x-utils'
import type { ActionContext } from 'vuex'
import type { ActionClass, TaggingFeedback, TaggingState } from '../../../models'
import type { TaggingService } from '../../../services/interfaces'
import { CONTAINER } from '../../../config/inversify.config'
import { TYPES } from '../../../config/inversify.types'
import { CONFIG_CONSTS } from '../../config/config.consts'

export class SubmitFeedbackAction implements ActionClass {
  static execute(
    this: void,
    { rootGetters }: ActionContext<TaggingState, unknown>,
    payload: TaggingFeedback,
  ): Promise<void> {
    const taggingService = CONTAINER.get<TaggingService>(TYPES.TaggingService)
    const { id: instance } = rootGetters[
      `${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.getters.currentInstance}`
    ] as Instance
    const sessionId = CONTAINER.get<SessionService>(TYPES.SessionService).getSessionId()
    return taggingService.submitFeedback(instance, payload, sessionId)
  }
}
